import React from "react";

import Box from "components/Box";

const Span = props => <Box as="span" {...props} />;

export default Span;
